import { Building, CirclePlus, Rotate3d, UserRound, Users } from "lucide-react";
import { useForm, SubmitHandler } from "react-hook-form";
import { LabeledBtn } from "./LabeledBtn";

type AddKnotFormInputs = {
    title: string;
    body: string;
};

type AddKnotViewProps = {
    handleNewKnot: (title: string, body: string) => Promise<void>
}

export const AddKnotView = (props: AddKnotViewProps) => {
    const { register, handleSubmit, reset } = useForm<AddKnotFormInputs>();
    const onSubmit: SubmitHandler<AddKnotFormInputs> = async (data) => {
        await props.handleNewKnot(data.title, data.body);
        reset();
    };

    return (
        <li>
            <div className="timeline-middle">
                <CirclePlus size={16} />
            </div>
            <div className="timeline-end mb-10 w-full">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <label className="form-control">
                        <div className="join join-vertical">
                            <div className="join-item input-bordered  flex flex-row gap-2">

                            </div>
                            <input className="input input-bordered join-item" placeholder="Title" {...register("title", { required: true })} />
                            <textarea className="textarea textarea-bordered h-24 join-item" placeholder="Body..." {...register("body", { required: true })}></textarea>
                        </div>
                    </label>
                    <div className="flex justify-end mt-4">
                        <button className="btn btn-primary" type="submit">Add</button>
                    </div>
                </form>
            </div>
            <hr />
        </li>
    )
}


export default AddKnotView